console.warn(
  "[PORTIS] THIS PACKAGE IS DEPRECATED, PLEASE USE OUR NEW SDK: npm install @portis/web3"
);
